exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "::-webkit-scrollbar{width:5px;height:7px}::-webkit-scrollbar-thumb{border-radius:10px;background:#eee}::-webkit-scrollbar-track{border-radius:10px;background:#ffffff}\n", ""]);

// exports
